module.exports = __webpack_public_path__ + "img/wa.0460ba7b.svg";